<template>
  <div>
    <SideLeft
      :leftsideStatus="leftSideStatus"
      @changeStatus="changeLeftSideStatus"
      :fStatus="filtrateProps.status"
      :fName="filtrateProps.name"
      :fSpecType="filtrateProps.specType"
      :fType="filtrateProps.type"
      @filtrate="sideFiltrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :fStatus="filtrateProps.status"
        :fName="filtrateProps.name"
        :fSpecType="filtrateProps.specType"
        :fType="filtrateProps.type"
        @clearKey="clearKey"
        @openCreateLabel="openCreateLabelModal"
      />
      <router-view
        v-if="isSysRights('PrintLabel.getPrintInfoBySupplier')"
        :first_loading="firstLoading"
        :items="labelList"
        @modiLabel="modiLabel"
        @delLable="delLable"
      />
      <no-rights v-else></no-rights>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/label/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <ModalCreateLabel
      :open="openCreateLabel"
      :data="modiLabelData"
      @changeSuccess="changeSuccess"
    />
    <confirmComponent
      @del_index_i="delLabelConfirm"
      :modal_id="delProp.modalId"
      :modal_title="delProp.title"
      :modal_text="delProp.text"
      :del_index="delProp.delIndex"
    />
    <api-loading :show="loading"></api-loading>
  </div>
</template>

<script>
import SideLeft from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头部
import { pagination } from "@components/pagination.js"; //分页
import ModalCreateLabel from "./modal-create-label.vue"; //建立面单模态框
import { confirmComponent } from "@components/components.js"; //公共组件

export default {
  components: {
    SideLeft,
    Header,
    Pagination: pagination,
    ModalCreateLabel,
    confirmComponent,
  },
  data() {
    return {
      firstLoading: true,
      loading: true,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("s-label-rowsPerPage"))
        ? parseInt(store.get("s-label-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      filtrateProps: {
        status: "",
        name: "",
        specType: "",
        type: "",
      },
      labelList: [],
      openCreateLabel: Symbol(),
      modiLabelData: null,
      delProp: {
        modalId: "modalDelLabel",
        title: this.$t("express.删除标签"),
        text: this.$t("express.确定要删除吗"),
        delIndex: "",
      },
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("s-label-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    getList() {
      if (!this.isSysRights("PrintLabel.getPrintInfoBySupplier")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        name: this.filtrateProps.name,
        status: this.filtrateProps.status,
        specType: this.filtrateProps.specType,
        type: this.filtrateProps.type,
      };
      $.api_call("api.PrintLabel.getPrintInfoBySupplier", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.labelList = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getLabel(id) {
      this.loading = true;
      $.api_call("api.PrintLabel.getPrintInfoBySupplier", { id }, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.labelList.forEach((e, i) => {
            if (e.id == id) {
              this.$set(this.labelList, i, r.Data.Results);
            }
          });
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/label/" + num, params: { page: num } });
      if (page == num) {
        this.getList();
      }
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ params: { page: 1 } });
      if (page == 1) {
        this.getList();
      }
    },
    sideFiltrate(status, name, specType, type) {
      (this.filtrateProps.status = status),
        (this.filtrateProps.name = name),
        (this.filtrateProps.specType = specType),
        (this.filtrateProps.type = type);
      this.toPage(1);
    },
    clearKey(type) {
      this.filtrateProps[type] = "";
      this.toPage(1);
    },
    openCreateLabelModal() {
      //新建面单
      this.modiLabelData = null;
      this.openCreateLabel = Symbol();
      $("#modalCreateLabel").modal("show");
    },
    modiLabel(item) {
      //修改面单
      this.modiLabelData = item;
      this.openCreateLabel = Symbol();
      $("#modalCreateLabel").modal("show");
    },
    changeSuccess(id) {
      //面单修改成功
      $("#modalCreateLabel").modal("hide");
      if (id) {
        this.getLabel(id);
        ShowTip(this.$t("express.修改商品标签成功"), "success");
      } else {
        ShowTip(this.$t("express.新建商品标签成功"), "success");
        this.toPage(1);
      }
      localStorage.setItem("createLabel", moment().unix());
    },
    delLable(id) {
      this.delProp.delIndex = id;
      $("#" + this.delProp.modalId).modal("show");
    },
    delLabelConfirm(id) {
      this.loading = true;
      $.api_call("api.PrintLabel.delPrint", { id }, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.getList();
          $(`#${this.delProp.modalId}`).modal("hide");
          ShowTip(this.$t("express.删除成功"), "success");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getList();
    let id = this.$route.params.id;
    if (id) {
      this.openCreateLabelModal();
    }
    //  if(store.get("goLabelFirst")){
    //  	store.remove("goLabelFirst");
    //  	this.openCreateLabelModal();
    //  }
  },
};
</script>
